import LiftUpPageBlock from './LiftUpPageBlock.vue';

bootVue('.vue-liftup', LiftUpPageBlock);
